import { useMemo } from 'react';
import { Table } from '@/components';
import { useSortableData } from '@/hooks';
import { useOffices, useOfficesPagination } from '../hooks';
import { officesTableColumns } from '../config';
import { OfficesFilter, OfficeApi } from '../models';
import { useNavigate } from 'react-router-dom';
import { Edit as EditIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

interface OfficesTableProps {
  filter?: OfficesFilter;
}

const OfficesTable = ({ filter }: OfficesTableProps) => {
  const navigate = useNavigate();
  const columns = useMemo(() => officesTableColumns, []);

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useOfficesPagination();

  const { offices, isOfficesLoading, totalItems, totalPages } = useOffices({
    filters: filter,
    paginated: {
      page: currentPage,
      pageSize: pageSize,
    },
  });

  const { sortedData, selectedSort, handleSort } = useSortableData({
    data: offices,
    currentPage: currentPage,
    filters: filter,
  });

  const renderActions = (rowData: OfficeApi) => (
    <IconButton
      onClick={() =>
        navigate(`/inventory/geography/offices/edit/${rowData.id}`)
      }
    >
      <EditIcon />
    </IconButton>
  );

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded shadow-sm gap-5'>
      {offices?.length > 0 ? (
        <Table
          columns={columns}
          data={sortedData}
          selectedSort={selectedSort}
          handleSort={handleSort}
          renderActions={renderActions}
          isLoading={isOfficesLoading}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: handlePageChange,
            onRowsPerPageChange: handlePageSizeChange,
          }}
        />
      ) : (
        'No hay registros por el momento'
      )}
    </div>
  );
};

export default OfficesTable;
